import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { Observable, combineLatest, map, of } from 'rxjs';

import { ProductContextDirective } from 'ish-core/directives/product-context.directive';
import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { ProductLinks } from 'ish-core/models/product-links/product-links.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ProductCompletenessLevel } from 'ish-core/models/product/product.model';
import { ProductAddToBasketComponent } from 'ish-shared/components/product/product-add-to-basket/product-add-to-basket.component';
import { ProductImageComponent } from 'ish-shared/components/product/product-image/product-image.component';
import { ProductNameComponent } from 'ish-shared/components/product/product-name/product-name.component';
import { ProductPriceComponent } from 'ish-shared/components/product/product-price/product-price.component';
import { ProductQuantityComponent } from 'ish-shared/components/product/product-quantity/product-quantity.component';

@Component({
  selector: 'custom-suggested-for-you',
  templateUrl: './suggested-for-you.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    ProductContextDirective,
    ProductImageComponent,
    ProductNameComponent,
    ProductPriceComponent,
    ProductQuantityComponent,
    ProductAddToBasketComponent,
    AsyncPipe,
  ],
})
export class SuggestedForYouComponent implements OnChanges {
  private shoppingFacade = inject(ShoppingFacade);

  /**
   * list of products which are assigned to the specific product link type
   */
  readonly links = input<ProductLinks>(undefined);
  /**
   * title that should displayed for the specific product link type
   */
  readonly productLinkTitle = input<string>(undefined);
  /**
   * display only available products if set to 'true'
   */
  readonly displayOnlyAvailableProducts = input(false);

  suggestedProducts$: Observable<ProductView[]>;

  ngOnChanges() {
    this.suggestedProducts$ = this.displayOnlyAvailableProducts()
      ? combineLatest(
          this.links().products.map(sku => this.shoppingFacade.product$(sku, ProductCompletenessLevel.List))
        ).pipe(map(products => products.filter(p => p.available).map(p => p)))
      : of();
  }
  getClass(length: number): string {
    if (length === 1) {
      return 'suggest-fluid';
    } else if (length === 2) {
      return 'suggest-half';
    } else {
      return 'suggest-three';
    }
  }
}
